import * as React from "react"
export const Svg_063 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M26.043 29.428h6.914v3.226h-6.914v-3.226Z" />
    <path fill="url(#b)" d="M21.299 36.111H37.7v3.528H21.3V36.11Z" />
    <path
      fill="url(#c)"
      d="m48.702 19.057-15.53-15.53-.002.002a5.177 5.177 0 0 0-3.67-1.523c-1.432 0-2.73.582-3.67 1.523l-.002-.002-15.53 15.53H0v37.937h59V19.057H48.702ZM41.158 50.08H17.842V32.654h4.744v-6.683h13.828v6.683h4.744V50.08Zm-25.97-31.023 9.624-9.625a5.2 5.2 0 0 0 4.688 2.96 5.2 5.2 0 0 0 4.688-2.96l9.625 9.625H15.187Z"
    />
    <path fill="url(#d)" d="M21.299 43.096H37.7v3.527H21.3v-3.527Z" />
    <defs>
      <linearGradient
        id="a"
        x1={27.642}
        x2={28.554}
        y1={29.912}
        y2={33.076}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={25.092}
        x2={25.581}
        y1={36.641}
        y2={40.322}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={13.644}
        x2={38.904}
        y1={10.254}
        y2={54.118}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={25.092}
        x2={25.581}
        y1={43.625}
        y2={47.306}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)